import { render } from "./TheProfessionalDocumentUpload.vue?vue&type=template&id=40e7fc60"
import script from "./TheProfessionalDocumentUpload.vue?vue&type=script&lang=js"
export * from "./TheProfessionalDocumentUpload.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__